import * as actions from "store/actions";

export const systemConfigurationFetchedFromServer = (response) => ({
    type: actions.SYSTEM_CONFIGURATION_FETCHED_FROM_SERVER,
        payload: response,
});